import React, {useState, forwardRef, useEffect} from 'react';
import './Post.css';
import InputOption from "./InputOption";
import { Avatar } from '@material-ui/core';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined';
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import { db } from './firebase';

const Post = forwardRef(({user, username, postId, name, description, message, photoUrl, image, timestamp}, ref) => {

    const [comments, setComments] = useState([]);
    const [comment, setComment] = useState("");
    const [ count, setCount] = useState(0);

    
    useEffect(() => {
        let unsubscribe;
        if (postId) {
            unsubscribe=db
                .collection("posts")
                .doc(postId)
                .collection("comments")
                .onSnapshot((snapshot)=>{
                    setComments(snapshot.docs.map((doc)=>doc.data()));
                });
        }
        return () => {
            unsubscribe();
        }
        }, [postId])
    
        const postComment = (e) => {
            e.preventDefault();
    
            db.collection("posts").doc(postId).collection("comments").add({
            text: comment,
            name: user.displayName,
            photoUrl: user.photoUrl || "",
            });
            setComment("");
        };
      
        return(
            <div ref={ref} className="post">
                <div className="post__header">
                    <Avatar src={photoUrl}>{name[0]}</Avatar>
                    <div className="post__info">
                        <h2>{name}</h2>
                        <p>{new Date(timestamp?.toDate()).toUTCString()}</p>
                        <p>{description}</p>
                    </div>
                </div>
                <div className="post__body">
                    <p>{message}</p>
                </div>
                <div className="post__image">
                    <img src={image} alt=''/>
                </div>
    
                <div className="post__buttons">
                    
                    <div className="post__buttonLike">
                    <ThumbUpIcon onClick={() => setCount(count + 1)} color="black"/>
                    <div>{count}</div>
                    <p className="like">Like</p>
                    </div>
                    
                <InputOption Icon={ChatOutlinedIcon} title="Comment" color="gray"/>
                <InputOption Icon={ShareOutlinedIcon} title="Share" color="gray"/>
                <InputOption Icon={SendOutlinedIcon} title="Send" color="gray"/>
            </div>
            <div className="post__comments">
                    {comments.map((comment) => (
                    <p>
                    <Avatar src={comment.photoUrl} className="post__avatar"/>
                    <strong>{comment.name}</strong>{comment.text}
                    </p>
                    ))}
                    {name && (
                    <form className="post__commentBox">
                        <input
                        className="post__input"
                        type="text"
                        placeholder=" Add a comment..."
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        />
                        <button
                        disabled={!comment}
                        className="post__buttonComment"
                        type="submit"
                        onClick={postComment}
                        >
                        Send Comment
                        </button>
                    </form>
                )}
            </div>
        </div>

    )
})

export default Post